export default __webpack_public_path__ + "static/media/section2-bg6.bf71bae8.png";